export const categories = [
  {
    id: "yule",
    name: "娱乐圈",
    slug: "yule",
    description: "娱乐圈最新八卦、明星动态、综艺幕后爆料",
    icon: "ri-star-line",
  },
  {
    id: "zhibo",
    name: "直播圈",
    slug: "zhibo",
    description: "网红主播八卦、直播圈内幕、平台纷争爆料",
    icon: "ri-live-line",
  },
  {
    id: "dianshi",
    name: "影视圈",
    slug: "dianshi",
    description: "电影电视剧拍摄内幕、演员关系、片场爆料",
    icon: "ri-movie-2-line",
  },
  {
    id: "yinyue",
    name: "音乐圈",
    slug: "yinyue",
    description: "歌手动态、音乐节幕后、版权纷争内幕",
    icon: "ri-music-line",
  },
  {
    id: "tiyu",
    name: "体育圈",
    slug: "tiyu",
    description: "体育明星八卦、转会内幕、赛事周边爆料",
    icon: "ri-basketball-line",
  },
  {
    id: "shishang",
    name: "时尚圈",
    slug: "shishang",
    description: "时尚品牌内幕、模特圈八卦、设计师动态",
    icon: "ri-shirt-line",
  },
  {
    id: "keji",
    name: "科技圈",
    slug: "keji",
    description: "科技公司内幕、产品发布爆料、行业八卦",
    icon: "ri-smartphone-line",
  },
  {
    id: "wangluo",
    name: "网络热闻",
    slug: "wangluo",
    description: "网络热门事件、社交媒体热议、网友爆料",
    icon: "ri-fire-line",
  },
];

export const categoryMap: Record<string, typeof categories[number]> = {};
categories.forEach(cat => { categoryMap[cat.slug] = cat; });